import { IconProps } from '@euler/app/components/icons/types';
import { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const ErpIntegrationIcon = memo(
  ({ size, style, color = '#0078FF' }: IconProps) => (
    // The glyph fills its 1024 box edge to edge, while the Icomoon glyphs the
    // other settings rows use carry built-in padding — so pad the viewBox to
    // render it at ~80% of `size` and keep the row's icons the same weight.
    <Svg width={size} height={size} viewBox="-128 -128 1280 1280" style={style}>
      <Path
        d="M491.04 642.72c-52.784 52.64-103.856 77.104-154.832 77.104-123.728 0-208.128-84.736-208.128-207.568 0-114.304 87.04-192.528 208.128-192.528 129.568 0 224.4 94.88 238.816 278.08l0.496 6.896c9.28 138.688 89.44 228.56 201.232 241.728 101.072 11.888 202.496-44.48 234.08-138.208 61.776-183.408-103.52-344.832-291.264-279.28l42.32 120.56c87.456-30.544 155.28 35.68 127.52 118.048-11.248 33.376-54.016 57.152-97.648 52.016-47.568-5.6-81.6-42.64-88.048-118.032l-0.4-5.328C686.432 343.68 537.36 192 336.208 192 147.2 192 0 324.256 0 512.256 0 705.44 141.552 847.552 336.208 847.552c87.76 0 170.112-39.408 245.392-114.496l-90.56-90.32z"
        fill={color}
      />
    </Svg>
  ),
);
